import { SpinnerService } from 'src/app/services/spinner.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { objProveedorFrm } from 'src/app/modulos/archivos/proveedor/nuevoproveedor/objConfiguracionProveedor.model'
import { BuscarService } from 'src/app/services/buscar.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component';
import { Proveedor } from 'src/app/models/pproveedor.model';
//
import { ClienteService } from 'src/app/services/cliente.service'
import { CondicionPagoService } from 'src/app/services/condicion-pago.service'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { bancoService } from 'src/app/services/bancos.service'
import { MonedaService } from 'src/app/services/moneda.service'
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { CondicionesPago } from 'src/app/models/CondicionesPago.model';
import { Contacto } from 'src/app/models/Contacto.model';
import { ClienteDirecciones } from 'src/app/models/ClienteDirecciones.model';
import { ClienteEspecificaciones } from 'src/app/models/ClienteEspecificaciones.model';
import { ClienteBancos } from 'src/app/models/ClienteBancos.model';
import { ContactoService } from 'src/app/services/contacto.service'
import { RecursosService } from 'src/app/services/recursos.service';
import { ContactoFrmComponent } from 'src/app/shared/modals/contacto-frm/contacto-frm.component';
import { CpagoComprasService } from 'src/app/services/cpago-compras.service';
import { DataService } from 'src/app/services/dataService.service';
import { MdIcUbigeoEdtComponent } from 'src/app/shared/modals/md-ic-ubigeo-edt/md-ic-ubigeo-edt.component';
import { StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-modificar-proveedor',
  templateUrl: './modificar-proveedor.component.html',
  styleUrls: ['./modificar-proveedor.component.css']
})
export class ModificarProveedorComponent implements OnInit {
  @Input() codpro;


  @ViewChild('selectInsertar') selectInsertar: ElementRef;
  @ViewChild('selectModificar') selectModificar: ElementRef
  @ViewChild('interlocutor') interlocutor: ElementRef
  @ViewChild('tipopersonatab') tipopersonatab: ElementRef


  @ViewChild(ModificarProveedorComponent) tableclases: ModificarProveedorComponent | any;
  @ViewChild(ModificarProveedorComponent) tablecontactos: ModificarProveedorComponent | any;
  @ViewChild(ModificarProveedorComponent) tableespecificaciones: ModificarProveedorComponent | any;
  @ViewChild(ModificarProveedorComponent) tablebancos: ModificarProveedorComponent | any;

  ParamDocumento = new Proveedor();
  encontro: boolean = false;
  identidad: boolean = true;
  isnatural: boolean = true;
  vista: number = 1;
  tamanoidentidad: number;
  disabledInterlocutor: boolean = false;
  objProveedor = new objProveedorFrm();
  public buscarLimpiarBoton: string = 'buscar';
  tident: string = '';
  public proveedores: any[] = [];
  //lista para clases
  clases = [];
  //lista para las condiciones de PAgo
  condicionesPago = [];
  //lista para contactos
  contactos = [];
  //lista para especificaciones
  especificaciones = [];
  //lista para direcciones de envío
  direcciones = [];
  //lista para bancos
  bancos = [];

  //combo para clases
  listaclases = [];
  listacodigos = [];
  listacondpago = [];

  //llamar a servicios combo
  identidades: any = []
  vendedor: any = []
  titulolista: any = []
  tipopersona: any = []
  clienteRegimenes: any = []
  mediospago: any = []
  public mostrar: boolean = false;
  codigoCliente: any = [];


  public tabModificar: boolean = false;
  public tabClases: boolean = true;
  public tabCondicionesPago: boolean = true;
  public tabCreditos: boolean = true;
  public tabContactos: boolean = true;
  public tabDireccionesEnvio: boolean = true;
  public tabEspecificaciones: boolean = true;
  public tabBanco: boolean = true;

  public clasesSelect: any[] = [];
  public mostrarTab: boolean = true;
  public disabledCliente: boolean = false;
  public flagDisabledButtons = true;

  public disabledGuardar: boolean = true;

  closeResult = '';
  modal: NgbModalRef;

  //MODALS
  //Variables para Clase
  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;
  disabledCodigosClaseCombo: boolean = true;
  //Variables Modificar Clase
  editinputcla: any;
  editinputdescla: any;
  editinputcodigo: any;
  editinputdescodigo: any;
  editclase: any;
  editcond: any;
  editcontacto: any;
  editbanco: any;
  editdireccion: any;
  editespecificacion: any;
  //ATRIBUTOS DIRECCION ENVIO
  codInterlocutor: string;
  codEnvioUpd: number;
  desEnvioUpd: string;
  direccionE1Upd: string;
  referenciaEnvioUpd: string;
  telefonoEnvioUpd: string;
  codEanEnvioUpd: string;
  celularEnvioUpd: string;
  botonUbigueoDireccionEnvio: boolean;
  //  especificacion
  especificacion: any = [];
  //Checks de condicion de pago
  public codCondicionPago: number;
  public desCondicionPago: string;
  public predeterminado: boolean;
  public activo: boolean;

  //ATRIBUTOS ESPECIFICACIONES
  public disabledDecimalUpd: boolean = true;
  public disabledTextoUpd: boolean = true;
  public disabledCaracterUpd: boolean = true;
  public disabledFechaUpd: boolean = true;
  public disabledTiempoUpd: boolean = true;
  public disabledNumeroUpd: boolean = true;

  codEspecificacionUpd: number = null;
  desEspecificacionUpd: string = '';
  decimalUpd: number = null;
  textoUpd: string = '';
  caracterUpd: string = '';
  fechaUpd: string = '';
  tiempoUpd: string = '';
  numeroUpd: number = null;
  //Modificar condiciones de pago
  public codCondicionPagoUpd: number;
  public desCondicionPagoUpd: string;
  public predeterminadoUpd: boolean;
  public activoUpd: boolean;
  condicionespago = [];


  //ESPECIFICACION
  tipoConfirmar: string = 'Insert';
  //ENTRADAS
  public codEspecificacion: number;
  public desEspecificacion: string;
  public decimal: number;
  public texto: string;
  public caracter: string;
  public fecha: string;
  public tiempo: string;
  public numero: number;
  //MODALS DE DISABLED
  public disabledDecimal: boolean;
  public disabledTexto: boolean;
  public disabledCaracter: boolean;
  public disabledFecha: boolean;
  public disabledTiempo: boolean;
  public disabledNumero: boolean;

  //Atributos para crear direccion envío
  public codEnvio: number;
  public desEnvio: string = '';
  public direccionE1: string = '';
  public referenciaEnvio: string = '';
  public telefonoEnvio: string = '';
  public codEanEnvio: string = '';
  public celularEnvio: string = '';

  //ATRIBUTOS DE MODIFICARBANCO

  codBancoUpd: number = null;
  desBancoUpd: string = '';
  codTipoCuentaUpd: number = null;
  desTipoCuentaUpd: string = '';
  codMonedaUpd: string = '';
  desMonedaUpd: string = '';
  desCuentaUpd: string = '';

  codBanco: number = null;
  desBanco: string = '';
  codTipoCuenta: number = null;
  desTipoCuenta: string = '';
  codMoneda: string = '';
  desMoneda: string = '';
  desCuenta: string = '';

  financieras: any = [];
  tipocuentas: any = [];
  monedas: any = [];

  public disabledBotonBanco: boolean = true;
  public disabledTipoCuenta: boolean = true;
  public disabledMoneda: boolean = true;

  public _sunatImage: any = {};

  //Clase temporal a guardar
  ClaseTemp = new ClienteClase();
  CondicionTemp = new CondicionesPago();
  ContactoTemp = new Contacto();
  EspecifiacionTemp = new ClienteEspecificaciones();
  DireccionTemp = new ClienteDirecciones();
  BancoTemp = new ClienteBancos();

  public _recursos: any = {};

  public activoDirecEnvio: boolean = false;

  Ubigeobloc: boolean = false;

  disable_codigo: any = false;
  sessionInfo: any;

  constructor(
    private clienteService: ClienteService,
    private proveedorService: ProveedorService,
    private _buscarService: BuscarService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private CondicionPagoService: CondicionPagoService,
    private interlocutorService: InterlocutorService,
    private bancoService: bancoService,
    private MonedaService: MonedaService,
    private VendedorService: VendedorService,
    private contactoService: ContactoService,
    private recursosService: RecursosService,
    private cpagoComprasService: CpagoComprasService,
    public dataService: DataService,
    private toastr: ToastrService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService2: NgbActiveModal,

  ) {
    //this.codpro =  this._route.snapshot.paramMap.get('codpro');

  }

  ngOnDestroy() {
    this.dataService.vista = 0;
    console.log("On Destroy");
  }

  ngOnInit(): void {

    this.encontro = true;
    this.disabledInterlocutor = false;


    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo.factores.codigoProveedorAutomatico != null &&
      this.sessionInfo.factores.codigoProveedorAutomatico == true) {
      this.disable_codigo = true;
    }


    this.spinnerService.activarLoading(true);
    this.recursosService.recursosIC().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this._recursos = resp.body;
      if (this._recursos != null && this._recursos.personas != null)
        this.tipopersona = this._recursos.personas;
      if (this._recursos != null && this._recursos.identidades != null)
        this.identidades = this._recursos.identidades;
      if (this._recursos != null && this._recursos.vendedores != null)
        this.vendedor = this._recursos.vendedores;
      if (this._recursos != null && this._recursos.tituloListas != null)
        this.titulolista = this._recursos.tituloListas;
      if (this._recursos != null && this._recursos.impositivos != null)
        this.clienteRegimenes = this._recursos.impositivos;

    }, err => {
      this.spinnerService.activarLoading(false);
    });

    this.obtenerListaClases();
    this.obtenerListaCondPago();
    this.ObtenerEspecificaciones();
    //bancos
    this.ObtenerEntidad();
    this.ObtenerTipoCuentas();
    this.ObtenerMonedas();
    this.ObtenerCondPago();
    this.onNexFocus('Insert')
    this.getAdjuntos();
    this.onBlurCodInterlocutor(this.codpro);
  }

  public ObtenerCondPago() {
    this.spinnerService.activarLoading(true);
    this.cpagoComprasService.buscar().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      console.log("condiciones de pago");
      console.log(resp.body.list);
      this.condicionespago = resp.body.list;
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }


  onChangeactivoDirecEnvio(isChecked: boolean) {
    if (isChecked) {
      this.activoDirecEnvio = true;
    } else {
      this.activoDirecEnvio = false;
    }
  }


  obtenerListaClasesCodigos(clase: any) {
    this.proveedorService.obtener_lista_clases_codigos_proveedores(clase).subscribe(response => {
      this.spinnerService.activarLoading(false)
      console.log(response.body);
      console.log("clases")
      this.listacodigos = response.body;
      this.codCodigoClase = this.listacodigos[0].codigo
    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No contiene codigos.', 'warning', 'Aceptar', null, null, null);
    })
    console.log("problema con codigos")
    //this.spinnerService.activarLoading(false)
  }

  obtenerListaClases() {
    this.proveedorService.obtener_lista_clases_proveedor().subscribe(response => {
      console.log(response.body);
      console.log("clases de combo")
      this.listaclases = response.body;
    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No contiene lista de clases.', 'warning', 'Aceptar', null, null, null);
    })
    console.log("problema con lista de clases")
  }


  addUbigeo() {
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.componentInstance.codDepart = "00";
    referenciaModal.result.then((data) => {
      if (this.clases == null)
        this.clases = [];
      if (data != null) {
        data.forEach(element => {
          this.clases.push(element);
        });
      }
      if (this.clases.find(x => x.clase == 14) == null) {
        console.log("CLASE CLASES 132")
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }



  obtenerListaCondPago() {
    this.CondicionPagoService.busar("", true).subscribe(response => {
      this.listacondpago = response.body.list;
    })
  }



  _mNuevoContacto() {
    const referenciaModal = this.modalService.open(ContactoFrmComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.componentInstance.codInterlocutormod = this.objProveedor.codcli
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      this.insertAsignarContacto(data.codcont);
    }, (reason) => {
      console.log(reason);
    });
  }

  _mEditarContacto(item: any) {

    let _contact: any = {};
    _contact.codcont = item.codcont;
    _contact.nomcont = item.nomcont;
    _contact.direccion = item.direccion;
    _contact.hobby = item.hobby;
    _contact.telefono = item.telefono;
    _contact.activo = item.activo;
    _contact.palabraclave = item.palabraclave;
    _contact.email = item.correo;
    _contact.cargo = item.cargo;

    const referenciaModal = this.modalService.open(ContactoFrmComponent, { backdrop: 'static', size: 'lg' });

    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.contacto = _contact;
    referenciaModal.componentInstance.codInterlocutor = this.objProveedor.codcli
    referenciaModal.result.then((data) => {
      if (data.actualizado != undefined && data.actualizado != null && data.actualizado) {
        this.contactos = [];
        this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
          this.contactos = response.body.contactos;
        }, err => {
          this.spinnerService.activarLoading(false);
          console.log(err);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }


  ObtenerEspecificaciones() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {
      console.log(response.body);
      console.log("clases de ObtenerEntidad")
      this.especificacion = response.body;
    })
    console.log("problema con lista de ObtenerEntidad")
  }
  ObtenerEntidad() {
    this.bancoService.obtenerEntidad().subscribe(response => {
      console.log(response.body);
      console.log("clases de ObtenerEntidad")
      this.financieras = response.body;
    })
    console.log("problema con lista de ObtenerEntidad")
  }
  ObtenerTipoCuentas() {
    this.bancoService.obtenerTipoCuentas().subscribe(response => {
      console.log(response.body);
      console.log("clases de ObtenerTipoCuentas")
      this.tipocuentas = response.body;
    })
    console.log("problema con lista de ObtenerTipoCuentas")
  }

  ObtenerMonedas() {
    this.MonedaService.buscar().subscribe(response => {
      console.log(response.body);
      console.log("clases de ObtenerTipoCuentas")
      this.monedas = response.body.list;
    })
    console.log("problema con lista de ObtenerTipoCuentas")
  }

  ObtenerCodpag() {
    this.MonedaService.buscar().subscribe(response => {
      console.log(response.body);
      console.log("clases de ObtenerTipoCuentas")
      this.monedas = response.body.list;
    })
    console.log("problema con lista de ObtenerTipoCuentas")
  }

  numerodident = 0;

  modificarCliente() {
    /*
    if (this.objAlmacen.codalm == null) {
      basicAlert('El campo "Código" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objAlmacen.tipinv == '' || this.objAlmacen.tipinv == null) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Tipo de inventario" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    }
 
    this.sucursales.forEach(element => {
      if (element.codsuc == this.inputclase) {
        this.desputclase = element.sucursal;
      }
    });
 
    */

    if (this.objProveedor.dident == null) {
      this.numerodident = 0;
    }
    else {
      this.numerodident = this.objProveedor.dident.length;
    }
    if (this.objProveedor.tident.toString() == '06' || this.objProveedor.tident.toString() == '01') {
      if (this.tamanoidentidad != 0 && (this.objProveedor.dident == null)) {
        basicAlert('El campo "Doc. de identidad" es requerido y debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }
    if (this.objProveedor.tident.toString() == '06' || this.objProveedor.tident.toString() == '01') {
      if (this.tamanoidentidad != 0 && this.numerodident != this.tamanoidentidad) {
        basicAlert('El campo "Doc. de identidad" debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }
    // if(this.objProveedor.dident.length != this.tamanoidentidad){
    //   basicAlert('El campo "Doc. de identidad" debe tener '+ this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
    //   return;   
    // }

    this.ParamDocumento.id_cia = this.objProveedor.id_cia;
    this.ParamDocumento.tipopersona = this.objProveedor.tipopersona;
    //this.ParamDocumento.valident = this.objProveedor.valident;
    this.ParamDocumento.tident = this.objProveedor.tident;
    this.ParamDocumento.codcli = this.objProveedor.codcli;
    //this.ParamDocumento.nombrescompletos = this.objProveedor.nombrescompletos;


    this.ParamDocumento.direc1 = (this.objProveedor.direc1 != undefined && this.objProveedor.direc1 != null && this.objProveedor.direc1.length > 0) ? this.objProveedor.direc1.trim() : "";
    this.ParamDocumento.direc2 = (this.objProveedor.direc2 != undefined && this.objProveedor.direc2 != null && this.objProveedor.direc2.length > 0) ? this.objProveedor.direc2.trim() : "";


    this.ParamDocumento.apellidopaterno = this.objProveedor.apellidopaterno;
    this.ParamDocumento.email = this.objProveedor.email;
    this.ParamDocumento.apeliidomaterno = this.objProveedor.apeliidomaterno;
    this.ParamDocumento.telefono = this.objProveedor.telefono;
    this.ParamDocumento.nombres = this.objProveedor.nombres;
    this.ParamDocumento.fax = this.objProveedor.fax;
    this.ParamDocumento.nrodni = this.objProveedor.nrodni;
    this.ParamDocumento.sexo = this.objProveedor.sexo;
    this.ParamDocumento.repres = this.objProveedor.repres;

    //this.ParamDocumento.titulolista = this.objProveedor.titulolista;
    this.ParamDocumento.codven = this.objProveedor.codven;
    this.ParamDocumento.exoimp = this.objProveedor.exoimp;
    this.ParamDocumento.regret = this.objProveedor.regret;
    //this.ParamDocumento.observ = this.objProveedor.observ;
    this.ParamDocumento.codtit = this.objProveedor.codtit;
    this.ParamDocumento.codtpe = this.objProveedor.codtpe;
    this.ParamDocumento.razonc = this.objProveedor.razonc.trim();
    //this.ParamDocumento.nombrescompletos = this.objProveedor.nombrescompletos
    this.ParamDocumento.dident = this.objProveedor.dident;
    //this.ParamDocumento.fecing = moment(this.objProveedor.fecing).format("YYYY-MM-DD");
    this.ParamDocumento.clases = this.clases;
    //this.ParamDocumento.regret = this.objProveedor.regret;
    this.ParamDocumento.contactos = this.contactos;
    //this.ParamDocumento.condicionespago = this.condicionesPago;
    this.ParamDocumento.especificaciones = this.especificaciones;
    this.ParamDocumento.direccionesenvio = this.direcciones;
    this.ParamDocumento.bancos = this.bancos;
    this.ParamDocumento.codpag = this.objProveedor.codpag;

    //this.ParamDocumento.diasgracia = this.objProveedor.diasgracia;
    this.ParamDocumento.limiteCredito = this.objProveedor.limiteCredito;


    console.log("se modificará así");
    console.log(this.ParamDocumento);

    this.spinnerService.activarLoading(true);
    this.proveedorService.actualizarProveedor(this.ParamDocumento).subscribe(response => {
      this.spinnerService.activarLoading(false);

      console.log(response);
      this.disabledInterlocutor = false;
      this.encontro = true;
      if (response.status === 200) {
        this.toastr.success('Se actualizó correctamente.', '', { positionClass: 'toast-bottom-left' })
        this.borrarDatos();
        this.buscarLimpiarBoton = 'buscar';
        this.dataService.vista = 0;
        this.mostrar = false;
        this.ParamDocumento = new Proveedor();
        this.vista = 1;
        this.cerrar()
      }
    }, error => {
      this.spinnerService.activarLoading(false);
      basicAlert(error.error, 'error', 'Aceptar');
      console.log("error");
    }
    );
  }
  actualizarLista: boolean = false;
  eliminarProveedor() {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {
        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          if (this.objProveedor != null && this.objProveedor.codcli != null) {
            this.spinnerService.activarLoading(true);
            this.proveedorService.eliminarProveedor(this.objProveedor.codcli).subscribe((resp: any) => {
              this.spinnerService.activarLoading(false);

              this.toastr.success('Se eliminó correctamente.', '', { positionClass: 'toast-bottom-left' })
              this.borrarDatos();
              this.buscarLimpiarBoton = 'buscar';
              this.dataService.vista = 0;
              this.actualizarLista = true;
              this.mostrar = false;
              this.ParamDocumento = new Proveedor();
              this.vista = 1;
              this.cerrar()
            }, err => {
              this.spinnerService.activarLoading(false);

            })
          }
        }
        this.modal.close();
      })
  }
  onNexFocus(tipo: string) {
    if (tipo == 'Insert') {
      timerOut(10).then((value: any) => {
        if (value) { this.interlocutor.nativeElement.focus(); }
      })
    } else {
      timerOut(10).then((value: any) => {
        if (value) { this.tipopersonatab.nativeElement.focus(); }
      })
    }
  }
  cancelarInsercion() {

    this.ParamDocumento = new Proveedor();
    this.borrarDatos();
    this.vista = 1;
    this.mostrar = false;
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.mostrar = false;
    this.disabledInterlocutor = false;
    this.encontro = true;
    this.cerrar();
    //this.dtTrigger.next();
    //this.dtTrigger.next();
  }
  onKeyEnterCodInterlocutor(e: any) {
    this.onBlurCodInterlocutor(this.objProveedor.codcli);
  }

  onBlurCodInterlocutor(codcli: string) {
    if (codcli != null || codcli != '') {
      this.spinnerService.activarLoading(true);
      this.getByCodInterlocutor(codcli, 1);
    }
  }
  getByCodInterlocutor(codcli: string, tipo: number) {

    this.codigoCliente = codcli;
    this.spinnerService.activarLoading(true);
    this.proveedorService.obtenerProveedor(codcli, null).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.dataService.vista = 1;
      this.dataService.tipo = 'proveedor';

      this.mostrar = true;
      console.log("Datos a Modificar");
      console.log(response);

      this.disabledInterlocutor = true;
      this.encontro = false;


      this.objProveedor.codcli = response.body.codcli;


      if (tipo == 1) {
        this.objProveedor.razonc = response.body.razonc;
        this.objProveedor.codtpe = response.body.codtpe;
        //this.objProveedor.fecing = response.body.fecing != null ? response.body.fecing : moment(new Date()).format("YYYY-MM-DD");;
        //this.objProveedor.valident = response.body.valident;
        this.onSelectTipoPersonaIns(response.body.codtpe);
        this.objProveedor.tident = response.body.tident;
        this.onSelectTipoIdentidadIns(response.body.tident);
        this.objProveedor.dident = response.body.dident != null ? response.body.dident : '';
        this.objProveedor.razonc = response.body.razonc != null ? response.body.razonc : '';
        //this.objProveedor.nombrescompletos = response.body.nombrescompletos != null ? response.body.razonc : '';
        this.objProveedor.direc1 = response.body.direc1 != null ? response.body.direc1 : '';
      }

      this.objProveedor.direc2 = response.body.direc2 != null ? response.body.direc2 : '';
      this.objProveedor.apellidopaterno = response.body.apellidopaterno != null ? response.body.apellidopaterno : '';
      this.objProveedor.apeliidomaterno = response.body.apeliidomaterno != null ? response.body.apeliidomaterno : '';
      this.objProveedor.nombres = response.body.nombres != null ? response.body.nombres : '';
      this.objProveedor.email = response.body.email != null ? response.body.email : '';
      this.objProveedor.telefono = response.body.telefono != null ? response.body.telefono : '';
      this.objProveedor.fax = response.body.fax != null ? response.body.fax : '';
      this.objProveedor.nrodni = response.body.nrodni != null ? response.body.nrodni : '';
      this.objProveedor.sexo = response.body.sexo;
      this.objProveedor.repres = response.body.repres;
      this.objProveedor.codven = response.body.codven;
      this.objProveedor.codtit = response.body.codtit;
      this.objProveedor.regret = response.body.regret;
      //this.objProveedor.observ = response.body.observ;
      this.objProveedor.codpag = response.body.codpag;
      this.objProveedor.exoimp = response.body.exoimp;
      this.objProveedor.factua = response.body.factua;
      this.objProveedor.fcreac = response.body.fcreac;
      this.objProveedor.ucreac = response.body.ucreac;
      this.objProveedor.uactua = response.body.uactua;
      //this.objProveedor.regret = response.body.regret;

      if (response.body.codpag == 0) {
        this.objProveedor.credito = "0"
      }
      if (response.body.codpag == 1) {
        this.objProveedor.credito = "1"
      }

      this.objProveedor.limiteCredito = response.body.limiteCredito;
      //this.objProveedor .diasgracia = response.body.diasgracia;

      //this.progressDirec1 = this.objProveedor.direc1.length + '%';
      //this.progressDirec2 = this.objProveedor.direc2.length + '%';

      this.clases = response.body.clases;

      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }


      this.condicionesPago = response.body.condicionespago;
      this.contactos = response.body.contactos;
      this.especificaciones = response.body.especificaciones;
      this.direcciones = response.body.direccionesenvio;
      this.bancos = response.body.bancos;

      this.onSelectTipoPersonaIns(this.objProveedor.codtpe);

      this.buscarLimpiarBoton = 'borrar';
      this.disabledCliente = true;
      this.mostrarTab = false;
      this.flagDisabledButtons = false;
      this.selectModalNuevo();
      setTimeout(() => {
        $('#cboTipoPersona').focus();
      }, 150);

      timerOut(500).then((value: any) => {
        if (value) { this.tipopersonatab.nativeElement.focus(); }
      })

    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status == 404) {
        basicAlert('Proveedor no encontrado', 'warning', 'Aceptar');
      }
      setTimeout(() => {

      }, 350);
    });
  }


  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  openModalInterlocutor() {

    let codcli: string = '';
    let razonc: string = this.objProveedor.razonc + "%";
    let nombres: string = '';
    let dident: string = '';
    let soloactivos: boolean = true;
    let limit: number = 350;
    let offset: number = 0;

    this.ParamDocumento.razonc = this.objProveedor.razonc;

    if (this.objProveedor.razonc.length > 0) {
      this.spinnerService.activarLoading(true);
      console.log(razonc);
      this.proveedorService.buscarProveedor(codcli, razonc, dident, limit, offset, false).subscribe((response: any) => {
        this.proveedores = response.body;
        this.mostrarModalProveedor();
      }, err => {
        if (err.status == 404) {
          basicAlert('No se encontró la lista de proveedores.', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
      return;
    }
  }

  mostrarModalProveedor() {
    const referenciaModal = this.modalService.open(ModalBusquedaProveedorComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
    //referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.proveedores = this.proveedores;

    referenciaModal.result.then((data) => {
      console.log(data);
      this.getByCodInterlocutor(data.codpro, 1)
    }, (reason) => {
      console.log(reason);
    });
  }

  borrarDatosInterlocutor() {
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objProveedor = new objProveedorFrm();
    //this.objProveedor.fecing = moment(new Date()).format("YYYY-MM-DD");
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.disabledCliente = false;
    this.proveedores = [];
    this.clases = [];
    this.condicionesPago = [];
    this.especificaciones = [];
    this.contactos = [];

    this.direcciones = [];
    /*this.creditos = [];
    
    this.contactos = [];
    this.bancos = [];
    this.contactosAsignados = [];
    this.especificaciones = [];
    this.direccionesEnvio = [];
    */
    this.mostrarTab = true;
    this.flagDisabledButtons = true;


    this.tabModificar = false;
    this.tabClases = true;
    this.tabCondicionesPago = true;
    this.tabCreditos = true;
    this.tabContactos = true;
    this.tabEspecificaciones = true;
    this.tabDireccionesEnvio = true;
    //this.botonUbigueo = false;

    $("#modificar-tab").addClass("active");
    $("#clases-tab").removeClass("active");
    $("#codpago-tab").removeClass("active");
    $("#creditos-tab").removeClass("active");
    $("#contacto-tab").removeClass("active");
    $("#especificacion-tab").removeClass("active");
    $("#direnvio-tab").removeClass("active");
    $("#banco-tab").removeClass("active");
    $('#datatableBancos').DataTable().destroy();
    setTimeout(() => {
      $('#desInterlocutor').focus();
    }, 250);
  }
  onSelectTipoPersonaIns(codTpe: number) {
    //console.log(codTpe);
    if (codTpe == 1) {
      this.tident = "06"
      this.isnatural = true
    } else {
      this.tident = "999999"
      this.isnatural = false
    }
  }
  @ViewChild('dident') dident: ElementRef;

  onSelectTipoIdentidadIns(tipid: string) {
    //evaluando tipo de identidad
    console.log("evaluando tipo de identidad");
    console.log(tipid);
    if (tipid == "01") {
      this.identidad = false
      this.isnatural = false
    } else {
      this.identidad = true
      this.isnatural = true
      this.objProveedor.nrodni = null
      this.objProveedor.nrodni = ""
    }
    this.identidades.forEach(element => {
      if (element.tident == tipid) {
        console.log(element)
        this.tamanoidentidad = element.tamano;
      }
    });
    console.log(this.tamanoidentidad);

    timerOut(50).then((value: any) => {
      if (value) { this.dident.nativeElement.focus(); }
    })
  }

  selectModalNuevo() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {
      let espec = response.body;
      this.especificaciones.forEach(element => {
        espec = espec.filter(function (dato) {
          if (dato.codigo == element.codesp) {
            return false;
          } else {
            return true;
          }
        });
      });
      console.log('ARREGLO FINAL SELECT:')
      console.log(espec);
      this.especificacion = espec;
    })
  }
  borrarDatos() {
    this.encontro = true;
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objProveedor = new objProveedorFrm();
    this.disabledGuardar = true;
    //this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");

    setTimeout(() => {
      $('#codTipoDocumento').focus();
    }, 150);
  }

  NuevoModal(content1: string) {
    this.spinnerService.activarLoading(true)
    this.codClase = this.listaclases[0].codigo
    this.disabledCodigosClaseCombo = false;
    this.obtenerListaClasesCodigos(this.codClase);
    this.activoDirecEnvio = true;

    this.open(content1)
    // this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }
  open(content) {
    this.modal = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
    this.modal.result.then((e) => {
      console.log("dialogo cerrado")
    });
  }
  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  editUbigeo() {

    let codDepart: string = '00';

    this.clases.forEach(element => {
      if (element.clase == 14) {
        codDepart = element.codigo;
      }
    });

    let codProv: string = null;
    this.clases.forEach(element => {
      if (element.clase == 15) {
        codProv = element.codigo;
      }
    });

    let codDist: string = null;
    this.clases.forEach(element => {
      if (element.clase == 16) {
        codDist = element.codigo;
      }
    });
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.codDepart = codDepart;
    referenciaModal.componentInstance.codProv = codProv;
    referenciaModal.componentInstance.codDist = codDist;
    referenciaModal.result.then((data) => {
      if (this.clases == null)
        this.clases = [];

      if (data != null) {

        this.clases.forEach(element => {
          if (element.clase == 14) {

            let departamento = data.find(item => item.clase == 14);;
            element.codigo = departamento.codigo;
            element.descodigo = departamento.descodigo;

          } else if (element.clase == 15) {

            let provincia = data.find(item => item.clase == 15);;

            element.codigo = provincia.codigo;
            element.descodigo = provincia.descodigo;


          } else if (element.clase == 16) {

            let distrito = data.find(item => item.clase == 16);
            element.codigo = distrito.codigo;
            element.descodigo = distrito.descodigo;


          }
        });

      }

      console.log(this.clases);

      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }

  ModalModificarClase(content2: string, item: any) {


    if (item.clase == 14 || item.clase == 15 || item.clase == 16) {
      this.editUbigeo();
    } else {
      this.disabledCodigosClaseCombo = false;
      this.listacodigos = [];
      this.codCodigoClase = null;
      console.log("Clase que se modificara")


      console.log(item)

      this.editinputcla = item.clase;
      this.editinputdescla = item.desclase;
      this.obtenerListaClasesCodigos(item.clase);
      this.editinputcodigo = item.codigo;
      this.editinputdescodigo = item.descodigo;
      this.editclase = item;

      this.open(content2)

      return;
    }


  }

  onChangeClases(clase: any) {
    this.spinnerService.activarLoading(true)
    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    this.obtenerListaClasesCodigos(clase);
  }
  //Predeterminado
  onChangePredeterminado(isChecked: boolean) {
    if (isChecked) {
      this.predeterminado = true;
    } else {
      this.predeterminado = false;
    }
  }
  //ACtivo
  onChangeActivo(isChecked: boolean) {
    if (isChecked) {
      this.activo = true;
    } else {
      this.activo = false;
    }
  }
  closeInsert() {
    this.borrarDatosInset();
    this.tipoConfirmar = 'Insert';
  }


  borrarDatosInset() {
    //this.disabledBotonClases = true;
    this.disabledCodigosClaseCombo = true;
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = null;
    this.desCodigoClase = '';
    //DIRECCION ENVíO
    this.codEnvio = null;
    this.desEnvio = '';
    this.direccionE1 = '';
    this.referenciaEnvio = '';
    this.telefonoEnvio = '';
    this.codEanEnvio = '';
    this.celularEnvio = '';
    //BANCos
    this.disabledTipoCuenta = true;
    this.disabledMoneda = true;
    this.disabledBotonBanco = true;


    //this.childModalClases.hide();
  }



  public messageTable = {
    emptyMessage: 'No hay información',
    totalMessage: 'total',
    selectedMessage: 'selected'
  }
  onCLickEspecificacion(data: any) {
    this.tipoConfirmar = 'InsertEspecificacion';
    console.log(data);
    this.codEspecificacion = data.codigo;
    this.desEspecificacion = data.descri;
    this.disabledDecimal = data.vreal;
    this.disabledTexto = data.vstrg;
    this.disabledCaracter = data.vchar;
    this.disabledFecha = data.vdate;
    this.disabledTiempo = data.vtime;
    this.disabledNumero = data.ventero;
  }
  onChangeFinanciera() {
    this.disabledTipoCuenta = false;
  }
  onChangeTipoCuenta() {
    this.disabledMoneda = false;
    this.disabledBotonBanco = false;
  }

  closeInsertBanco() {
    this.codBanco = null
    this.codTipoCuenta = null
    this.codMoneda = null
    this.desCuenta = ''
    this.disabledTipoCuenta = true;
    this.disabledMoneda = true;
    this.disabledBotonBanco = true;
  }

  importarDatosSunat() {

    const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static' });
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.ruc = this.objProveedor.dident;
    referenciaModal.result.then((data) => {
      console.log("se importo")
      console.log(data);

      this.objProveedor.codtpe = 2;
      this.onSelectTipoPersonaIns(this.objProveedor.codtpe);
      this.objProveedor.tident = '06';
      this.objProveedor.dident = data.ruc;
      this.objProveedor.direc1 = data.direc;
      this.objProveedor.razonc = data.razonc;

      this.getByCodInterlocutor(this.objProveedor.dident, 2);
      this.onSelectTipoIdentidadIns(this.objProveedor.tident);


      let digito1 = parseInt(String(data.ruc)[0])
      console.log("data.ruc primero");
      console.log(digito1);

      if (digito1 == 1) {
        this.objProveedor.codtpe = 1;
      }
      if (digito1 == 2) {
        this.objProveedor.codtpe = 2;
      }
    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });



  }
  //------------------ SECCIÓN DE ELIMINAR -------------------/// 
  EliminarClase(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {

          this.spinnerService.activarLoading(true);
          this.proveedorService.eliminarClase(this.objProveedor.codcli, data.clase).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.clases = [];
            this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {

              this.clases = response.body.clases;


              if (this.clases.find(x => x.clase == 14) == null) {
                this.Ubigeobloc = false;
              } else {
                this.Ubigeobloc = true;
              }


            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });

          this.clases = [...this.clases]

        }

        this.modal.close();

      })
  }
  EliminarContacto(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {


        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.proveedorService.eliminar_contacto_prov(this.objProveedor.codcli, data.codcont).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.contactos = [];
            this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
              this.contactos = response.body.contactos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.contactos = [...this.contactos]
        }
        this.modal.close();

      })
  }

  EliminarEspecificacion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.proveedorService.eliminar_especificacion(this.objProveedor.codcli, data.codesp).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.especificaciones = [];
            this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
              this.especificaciones = response.body.especificaciones;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
            this.selectModalNuevo();
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.especificaciones = [...this.especificaciones]
        }



        this.modal.close();
      })
  }

  EliminarDireccion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.proveedorService.eliminar_direcciones_envio_prov(this.objProveedor.codcli, data.codenv).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.direcciones = [];
            this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
              this.direcciones = response.body.direccionesenvio;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.direcciones = [...this.direcciones]
        }


        this.modal.close();
      })
  }

  EliminarBanco(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.proveedorService.eliminar_bancos_prov(this.objProveedor.codcli, data.codban, data.tipcta, data.tipmon).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.bancos = [];
            this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
              this.bancos = response.body.bancos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'warning', 'Aceptar');
          });
          this.bancos = [...this.bancos]
        }


        this.modal.close();
      })
  }
  ///////////////////////////////////////////////////////////////

  AbrirModificarEspecificacion(content6: string, cla: any) {
    console.log("Especificación que se modificara")
    console.log(cla)

    this.disabledDecimalUpd = false;
    this.disabledTextoUpd = false;
    this.disabledCaracterUpd = false;
    this.disabledFechaUpd = false;
    this.disabledTiempoUpd = false;
    this.disabledNumeroUpd = false;
    //this.obtenerListaClasesCodigos(cla.clase);
    this.desEspecificacionUpd = cla.descri
    this.decimalUpd = cla.vreal;
    this.textoUpd = cla.vstrg;
    this.caracterUpd = cla.vchar;
    this.fechaUpd = cla.vdate;
    this.tiempoUpd = cla.vtime;
    this.numeroUpd = cla.ventero;

    if (cla.vreal != null) {
      this.disabledDecimalUpd = true;
    }
    if (cla.vstrg != null) {
      this.disabledTextoUpd = true;
    }
    if (cla.vchar != null) {
      this.disabledCaracterUpd = true;
    }
    if (cla.vtime != null) {
      this.disabledTiempoUpd = true;
    }
    if (cla.ventero != null) {
      this.disabledNumeroUpd = true;
    }

    this.editespecificacion = cla;


    this.modalService.open(content6, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }

  AbrirModificarDirecciones(content: string, item: any) {

    //this.obtenerListaClasesCodigos(cla.clase);
    this.codEnvioUpd = item.codenv;
    this.desEnvioUpd = item.descri;
    this.direccionE1Upd = item.direc1;
    this.referenciaEnvioUpd = item.direc2;
    this.telefonoEnvioUpd = item.telenv;
    this.codEanEnvioUpd = item.codcen;
    this.celularEnvioUpd = item.faxenv;

    this.activoDirecEnvio = false;
    if (item.swacti == "S")
      this.activoDirecEnvio = true;

    this.editdireccion = item;

    this.open(content)

    return;
  }

  AbrirModificarBanco(content: string, cla: any) {


    //this.obtenerListaClasesCodigos(cla.clase);
    this.codBancoUpd = cla.codban;
    this.desBancoUpd = cla.desban;
    this.codTipoCuentaUpd = cla.tipcta;
    this.desTipoCuentaUpd = cla.descta;
    this.codMonedaUpd = cla.tipmon;
    //this.desMonedaUpd = cla.ventero;
    this.desCuentaUpd = cla.cuenta;

    this.editbanco = cla;


    this.open(content)

    return;
  }
  //Guardar Clase
  guardarClase() {

    if (this.codClase != null && this.codCodigoClase != null) {
      this.ClaseTemp = new ClienteClase();
      //obteniendo la descripcion de la clase en desClase
      this.ClaseTemp.clase = this.codClase;
      this.listaclases.forEach(element => {
        if (element.codigo == this.codClase) {
          console.log(element)
          this.desClase = element.descri;
        }
      });
      this.ClaseTemp.desclase = this.desClase;
      if (this.clases.find(x => x.clase == this.ClaseTemp.clase) == null) {
        // basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
        //obteniendo la descripcion del codigo en desCodigoClase
        this.listacodigos.forEach(element => {
          if (element.codigo == this.codCodigoClase) {
            console.log(element)
            this.desCodigoClase = element.descri;
          }
        });

        //this.ClaseTemp.codmot =this.inputclase;
        this.ClaseTemp.codigo = this.codCodigoClase;
        this.ClaseTemp.descodigo = this.desCodigoClase;

        this.clases.push(this.ClaseTemp);

      } else {
        basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
        return;
      }
      this.clases = [...this.clases]
      this.modal.close();

      this.tableclases = this.clases;
      console.log(this.ClaseTemp)
      this.codClase = null;
      this.desClase = '';
      this.codCodigoClase = null;
      this.desCodigoClase = '';
      this.ClaseTemp = new ClienteClase();
      this.borrarDatosInset();
    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.codClase == null) {
        dato = '"Clase"'
      } else if (this.codCodigoClase == null) {
        dato = '"Código"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

    }
  }
  //Actualizar Clase
  guardarActualizarClase() {
    console.log(this.clases)
    let arreglo = this.clases;
    let indice = arreglo.indexOf(this.editclase)

    console.log(indice)


    arreglo[indice].clase = this.editinputcla;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.editinputcla) {
        this.editinputdescla = element.descri;
      }
    });
    //  
    arreglo[indice].desclase = this.editinputdescla;

    arreglo[indice].codigo = this.editinputcodigo;
    //
    this.listacodigos.forEach(element => {
      if (element.codigo == this.editinputcodigo) {
        console.log(element)
        this.editinputdescodigo = element.descri;
      }
    });
    //
    arreglo[indice].descodigo = this.editinputdescodigo;


    this.clases = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }

  insertAsignarContacto(codcont: number) {
    this.spinnerService.activarLoading(true);
    this.proveedorService.insertContactoInterlocutor(this.objProveedor.codcli, codcont).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.borrarDatosInset();
      //this.response.emit();
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);

      this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
        this.contactos = response.body.contactos;
        console.log(this.contactos);

      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('Proveedor no encontrado', 'warning', 'Aceptar');
        }
      });

    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      } if (err.status == 400) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      } if (err.status == 500) {
        console.log(err);
        basicAlert('Error en el servicio, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      }
    });
  }


  guardarEspecificacion() {


    this.especificacion.forEach(element => {
      if (element.codigo == this.codEspecificacion) {
        console.log(element)
        this.desEspecificacion = element.descri;
      }
    });

    this.EspecifiacionTemp = new ClienteEspecificaciones();
    this.EspecifiacionTemp.codesp = this.codEspecificacion;
    this.EspecifiacionTemp.descri = this.desEspecificacion;

    this.EspecifiacionTemp.vreal = this.decimal;
    this.EspecifiacionTemp.vstrg = this.texto;
    this.EspecifiacionTemp.vchar = this.caracter;
    this.EspecifiacionTemp.vdate = this.fecha != '' ? moment(this.fecha).format("YYYY-MM-DD") : '';
    this.EspecifiacionTemp.vtime = this.tiempo;
    this.EspecifiacionTemp.ventero = this.numero;

    this.especificaciones.push(this.EspecifiacionTemp);
    this.especificaciones = [...this.especificaciones]
    this.modal.close();
    console.log("Especificacion temporal a guardar")
    this.tableespecificaciones = this.especificaciones;
    console.log(this.EspecifiacionTemp)

    this.codEspecificacion = null;
    this.desEspecificacion = null;
    this.decimal = null;
    this.texto = null;
    this.caracter = null;
    this.tiempo = null;
    this.numero = null;

    this.tipoConfirmar = 'Insert';

    new ClienteEspecificaciones();
    this.borrarDatosInset();
    this.selectModalNuevo();
  }
  ModificarEspecificacion() {
    console.log(this.especificaciones)
    let arreglo = this.especificaciones;
    let indice = arreglo.indexOf(this.editespecificacion)

    console.log(indice)

    arreglo[indice].vreal = this.decimalUpd;
    arreglo[indice].vstrg = this.textoUpd;
    arreglo[indice].vchar = this.caracterUpd;
    arreglo[indice].vdate = this.fechaUpd;
    arreglo[indice].vtime = this.tiempoUpd;
    arreglo[indice].ventero = this.numeroUpd;

    console.log("Especificaciones modificado");
    console.log(arreglo)
    this.especificaciones = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }

  ModificarDireccionEnvio() {
    console.log(this.direcciones)
    let arreglo = this.direcciones;
    let indice = arreglo.indexOf(this.editdireccion)

    console.log(indice)

    arreglo[indice].codenv = this.codEnvioUpd;
    arreglo[indice].descri = this.desEnvioUpd;
    arreglo[indice].direc1 = this.direccionE1Upd;
    arreglo[indice].direc2 = this.referenciaEnvioUpd;
    arreglo[indice].telenv = this.telefonoEnvioUpd;
    arreglo[indice].codcen = this.codEanEnvioUpd;
    arreglo[indice].faxenv = this.celularEnvioUpd;


    if (this.activoDirecEnvio) {
      arreglo[indice].swacti = "S";
    } else {
      arreglo[indice].swacti = "N";
    }



    this.direcciones = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }
  modificarBanco() {
    let bancomod: ClienteBancos = {

      codban: this.codBancoUpd,
      desban: this.desBancoUpd,
      tipcta: this.codTipoCuentaUpd,
      descta: this.desTipoCuentaUpd,
      tipmon: this.codMonedaUpd,
      cuenta: this.desCuentaUpd,
      id_cia: null,
    }

    this.spinnerService.activarLoading(true);
    this.proveedorService.actualizar_bancos_prov(this.objProveedor.codcli, bancomod).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      basicAlert('Se modificó con éxito.', 'success', 'Aceptar', null, null);
      this.bancos = [];
      this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
        this.bancos = response.body.bancos;
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err.error.mensaje);
      basicAlert(err.error, 'warning', 'Aceptar');
    });
    this.bancos = [...this.bancos]
    this.modal.close();
  }

  guardarBanco() {
    if (this.codBanco == null) {
      basicAlert("El campo 'Financiera' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codTipoCuenta == null) {
      basicAlert("El campo 'Tipo cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codMoneda == '') {
      basicAlert("El campo 'Moneda' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.desCuenta == '') {
      basicAlert("El campo 'N° cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    this.BancoTemp = new ClienteBancos();
    this.BancoTemp.codban = this.codBanco;
    this.financieras.forEach(element => {
      if (element.codigo == this.codBanco) {
        console.log(element)
        this.desBanco = element.descri;
      }
    });
    this.BancoTemp.desban = this.desBanco;
    /////////////////////////////////////////////
    this.BancoTemp.tipcta = this.codTipoCuenta;
    this.tipocuentas.forEach(element => {
      if (element.codigo == this.codTipoCuenta) {
        console.log(element)
        this.desTipoCuenta = element.descri;
      }
    });
    this.BancoTemp.descta = this.desTipoCuenta;
    this.BancoTemp.tipmon = this.codMoneda;
    this.BancoTemp.cuenta = this.desCuenta;

    this.spinnerService.activarLoading(true);
    this.proveedorService.insertar_bancos_prov(this.objProveedor.codcli, this.BancoTemp).subscribe((response: any) => {
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      console.log(response);
      this.spinnerService.activarLoading(false);

      this.codBanco = null;
      this.desBanco = '';
      this.codTipoCuenta = null;
      this.desTipoCuenta = null;
      this.codMoneda = '';
      this.desCuenta = null;


      this.bancos = [...this.bancos]
      this.modal.close();
      console.log("Clase temporal a guardar")
      this.tablebancos = this.bancos;
      this.BancoTemp = new ClienteBancos();
      this.borrarDatosInset();

      this.spinnerService.activarLoading(true);
      this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.bancos = response.body.bancos;
        console.log(this.bancos);
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('Proveedor no encontrado', 'warning', 'Aceptar');
        }
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 500) {
        basicAlert('Servicio no disponible, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })
  }

  nuevaDireccionEnvio() {

    if (this.desEnvio == '') {
      basicAlert("El campo 'Descripción' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.direccionE1 == '') {
      basicAlert("El campo 'Dirección' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    this.DireccionTemp = new ClienteDirecciones();

    this.DireccionTemp.codcli = this.objProveedor.codcli;
    this.DireccionTemp.codenv = this.codEnvio;
    this.DireccionTemp.descri = this.desEnvio;
    this.DireccionTemp.direc1 = this.direccionE1;
    this.DireccionTemp.direc2 = this.referenciaEnvio;
    this.DireccionTemp.telenv = this.telefonoEnvio;
    this.DireccionTemp.codcen = this.codEanEnvio;
    this.DireccionTemp.faxenv = this.celularEnvio;


    if (this.activoDirecEnvio != null && this.activoDirecEnvio) {
      this.DireccionTemp.swacti = "S"
    } else {
      this.DireccionTemp.swacti = "S"
    }


    // LLAMAR A SERVICIO DE INSERTAR DIRECCIONES
    this.spinnerService.activarLoading(true);
    this.interlocutorService.insertDireccionesEnvioInterlocutor(this.objProveedor.codcli, this.DireccionTemp).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log("SE insertará");
      console.log(response);
      this.borrarDatosInset();
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      this.direcciones = [];
      this.proveedorService.obtenerProveedor(this.objProveedor.codcli, null).subscribe((response: any) => {
        this.direcciones = response.body.direccionesenvio;
        console.log(this.direcciones);
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('Proveedor no encontrado', 'warning', 'Aceptar');
        }
      });

    }, err => {
      if (err.status == 404) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      } if (err.status == 400) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);;
      } if (err.status == 500) {
        console.log(err);
        basicAlert('Error en el servicio, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      }
    })

    this.direcciones = [...this.direcciones]
    this.modal.close();
    this.DireccionTemp = new ClienteDirecciones();

    this.borrarDatosInset();
  }
  onKeyUpNombresCompletos(event: any) {

    this.quitarEspaciosEnBlanco(event.target.value);
    console.log(event.target.value);
    let separacion = event.target.value.replace("  ", " ")

    let NOMBRES = separacion.split(" ");

    if (separacion == '') {
      NOMBRES = [];
    }

    if (NOMBRES.length == 0) {
      this.objProveedor.nombres = '';
      this.objProveedor.apellidopaterno = '';
      this.objProveedor.apeliidomaterno = '';
    }

    if (NOMBRES.length == 1) {
      this.objProveedor.apellidopaterno = '';
      this.objProveedor.apeliidomaterno = '';
      this.objProveedor.nombres = NOMBRES[0];
    }

    if (NOMBRES.length == 2) {
      this.objProveedor.apeliidomaterno = '';
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.nombres = NOMBRES[1];
    }

    if (NOMBRES.length == 3) {
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.apeliidomaterno = NOMBRES[1];
      this.objProveedor.nombres = NOMBRES[2];
    }

    if (NOMBRES.length == 4) {
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.apeliidomaterno = NOMBRES[1];
      this.objProveedor.nombres = NOMBRES[2] + ' ' + NOMBRES[3];
    }
  }
  quitarEspaciosEnBlanco(cadena: string) {
    let espaciosVacios: number = 0;
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena[0];
      if (element == ' ') {
        espaciosVacios = 1;
      }
    }
    //nombresyapellidos
    this.objProveedor.razonc = cadena.replace(cadena.substring(0, espaciosVacios), '');
    if (cadena.includes('  ')) {
      this.objProveedor.razonc = cadena.replace('  ', ' ')
    }
  }
  oneKeyupIdentidad(event: any) {

    if (this.objProveedor.tident == "01") {
      this.objProveedor.nrodni = this.objProveedor.dident;
    }
  }

  onBlurDocIdentidad() {
    console.log("this.objCliente.dident.length")
    console.log(this.objProveedor.dident.length)


  }

  cerrar() {
    this.modalService2.close(this.actualizarLista);
  }
  /**Docuemntos Adjuntos */
  onInputClick(e) {
    e.target.value = '';
  }
  fileToUpload: FileList = null;
  fileName: string = '';
  handleFileInput(files: FileList) {
    this.spinnerService.activarLoading(true);
    console.log("cantidad de archivos")
    console.log(files.length)
    console.log(files)
    this.fileToUpload = files;
    this.fileName = files.item(0).name;

    for (let i = 0; i < files.length; i++) {
      console.log("loop")
      console.log(files.item(i))
      this.readThisAdjunto(files.item(i))
    }
    this.spinnerService.activarLoading(false);
  }
  public base64convertido: any;
  nombrearchivo
  public formato: string;
  public size: number;
  public disabledbotonImagen: boolean = true;
  readThisAdjunto(inputValue: any): void {
    let imageBase64;
    var file: File = inputValue;
    var myReader: FileReader = new FileReader();

    console.log(file);
    myReader.onloadend = (e) => {
      imageBase64 = myReader.result;
      this.base64convertido = imageBase64.replace("data:" + file.type + ";base64,", "");
      this.formato = file.type;
      this.size = file.size;
      this.nombrearchivo = file.name;

      this.disabledbotonImagen = false;

      let obj: any = {
        //tipinv: this.tipinv, 
        // codart: this.codart,
        id_cia: this.sessionInfo.id_cia,
        codcli: this.codpro,
        razonc: this.objProveedor.razonc,
        base64: this.base64convertido,
        formato: this.formato,
        nombre: this.nombrearchivo,
        tipcli: 'B',
      }
      console.log("insertando obj:")
      console.log(obj)
      this.agregarAdjunto1(obj);
    }
    myReader.readAsDataURL(file);

  }
  agregarAdjunto1(obj) {
    this.spinnerService.activarLoading(true);
    this.proveedorService.insertarAdjuntoProveedor(obj).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.getAdjuntos();
    }, err => {
      if (err.status == 404) {
        console.log(err);
        this.spinnerService.activarLoading(false);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
      else
        this.spinnerService.activarLoading(false);
      basicAlert(err.error, 'warning', 'Aceptar', null, null, null);
    })
  }
  doc_adjuntos: any[] = [];
  getAdjuntos() {
    //FALTA CORREGIR
    this.spinnerService.activarLoading(true);
    this.proveedorService.obtenerAdjuntoProveedor(this.codpro, 'B').subscribe((response: any) => {
      console.log('Obteniendo Adjuntos', response.body);


      this.doc_adjuntos = response.body.map(objeto => ({
        ...objeto, // Copiamos todas las propiedades originales
        obs: objeto.observ // Agregamos el nuevo campo
      }));
      this.spinnerService.activarLoading(false);
    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        this.doc_adjuntos = [];
        // basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }
  eliminarAdj(data) {
    this.spinnerService.activarLoading(true);
    this.proveedorService.deleteAdjuntoProveedor(data.codcli, 'B',data.id).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log("-------- ADJUNTOS ------");
      console.log(response)
      this.getAdjuntos();
      this.toastr.success('Se eliminó correctamente.', '', { positionClass: 'toast-bottom-left' });
    }, err => {
      basicAlert(`Error`, 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    });

  }
  actualizar(data: any) {
    console.log('actualizando data: ', data);
    data.id_cia = this.sessionInfo.id_cia;
    data.observ = data.obs;
    this.spinnerService.activarLoading(true);
    this.proveedorService.actualizarAdjuntoProveedor(data).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      console.log('Se actualizo correctamente');
      this.getAdjuntos()
    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }
  descargarAdj(data) {
    this.spinnerService.activarLoading(true);
    this.proveedorService.descargarAdjuntoProveedor(data.codcli, 'B', data.id).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);

      if (response.byteLength > 0) {
        // let file = new Blob([response], { type: 'application/vnd.ms-excel' });
        let file = new Blob([response], { type: data.formato });

        var fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, data.nombre);
      } else {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
      }

    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }
}
